import { generateQueryKey } from '../../apis-infra';
import { getSharedQueryClient } from './queryClientInstance';
export const getCachedValue = (methodConfig, request) => {
  var _match$meta;
  const queryClient = getSharedQueryClient();
  const queryKey = generateQueryKey(methodConfig, request);
  const match = queryClient.getQueryCache().find(queryKey, {
    exact: true,
    stale: false
  });
  if (!match) {
    return undefined;
  }
  return {
    queryKey: match.queryKey,
    error: match.state.error,
    response: match.state.data,
    request: (_match$meta = match.meta) == null ? void 0 : _match$meta.request
  };
};
export const findInCache = (methodConfig, filters) => {
  const queryClient = getSharedQueryClient();
  const queryKey = generateQueryKey(methodConfig, filters == null ? void 0 : filters.request);
  const candidates = queryClient.getQueryCache().findAll({
    exact: false,
    stale: false,
    queryKey
  });
  const responses = candidates.map(query => {
    var _query$meta;
    return {
      queryKey: query.queryKey,
      error: query.state.error,
      response: query.state.data,
      request: (_query$meta = query.meta) == null ? void 0 : _query$meta.request
    };
  });
  if (!(filters != null && filters.pred)) {
    return responses;
  }
  return responses.filter(filters.pred);
};
//# sourceMappingURL=cacheOperations.js.map